/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowlogobottom3Inputs */

const en_aiflowlogobottom3 = /** @type {(inputs: Aiflowlogobottom3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, small at the bottom`)
};

const de_aiflowlogobottom3 = /** @type {(inputs: Aiflowlogobottom3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, klein unten`)
};

/**
* | output |
* | --- |
* | "Yes, small at the bottom" |
*
* @param {Aiflowlogobottom3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowlogobottom3 = /** @type {((inputs?: Aiflowlogobottom3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowlogobottom3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowlogobottom3(inputs)
	return de_aiflowlogobottom3(inputs)
});
export { aiflowlogobottom3 as "aiFlowLogoBottom" }